export default ["inactive", "active"]
